// Web-only strings for the channelPanel feature (keys prefixed `web.channelPanel.`), BOTH languages.
// Everything that already exists in the Apple tables (channel.info.*, people.*, channelNotifications.*,
// settings.*, channel.files.*, channel.pinned.*) is used from there, not repeated here.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.channelPanel.tab.pinned': 'Fijados',
    'web.channelPanel.openProfile': 'Abrir perfil',
    'web.channelPanel.editHeader': 'Editar encabezado',
    'web.channelPanel.removeConfirm': '¿Quitar?',
    'web.channelPanel.membersFilter': 'Filtrar miembros',
    'web.channelPanel.membersNoMatch': 'Nadie coincide con «%@».',
    'web.channelPanel.rosterFailed': 'No se pudo cargar la lista de miembros.',
    'web.channelPanel.pinnedFailed': 'No se pudieron actualizar los mensajes fijados.',
    'web.channelPanel.loadingMore': 'Cargando más…',
    'web.channelPanel.alreadyMember': 'Ya está aquí',
    'web.channelPanel.added': 'Se añadieron %d personas.',
    'web.channelPanel.addedOne': 'Se añadió 1 persona.',
    'web.channelPanel.addFailed': 'No se pudo añadir a nadie. Inténtalo de nuevo.',
    'web.channelPanel.noPeople': 'No se encontró a nadie.',
    'web.channelPanel.publicChannel': 'Canal público',
    'web.channelPanel.privateChannel': 'Canal privado',
    'web.channelPanel.directMessage': 'Mensaje directo',
    'web.channelPanel.groupMessage': 'Mensaje de grupo',
    'web.channelPanel.archived': 'Archivado',
    'web.channelPanel.favourite': 'Favorito',
    'web.channelPanel.working': 'Guardando…',
    'web.channelPanel.mutedByCategory': 'Silenciado por su categoría en la barra lateral.',
    'web.channelPanel.headerPlaceholder': 'Sin encabezado',
    'web.channelPanel.purposePlaceholder': 'Sin propósito',
    'web.channelPanel.openFile': 'Abrir archivo',
  },
  en: {
    'web.channelPanel.tab.pinned': 'Pinned',
    'web.channelPanel.openProfile': 'Open profile',
    'web.channelPanel.editHeader': 'Edit header',
    'web.channelPanel.removeConfirm': 'Remove?',
    'web.channelPanel.membersFilter': 'Filter members',
    'web.channelPanel.membersNoMatch': 'Nobody matches “%@”.',
    'web.channelPanel.rosterFailed': "Couldn't load the member list.",
    'web.channelPanel.pinnedFailed': "Couldn't refresh the pinned messages.",
    'web.channelPanel.loadingMore': 'Loading more…',
    'web.channelPanel.alreadyMember': 'Already here',
    'web.channelPanel.added': '%d people added.',
    'web.channelPanel.addedOne': '1 person added.',
    'web.channelPanel.addFailed': "Couldn't add anyone. Try again.",
    'web.channelPanel.noPeople': 'Nobody found.',
    'web.channelPanel.publicChannel': 'Public channel',
    'web.channelPanel.privateChannel': 'Private channel',
    'web.channelPanel.directMessage': 'Direct message',
    'web.channelPanel.groupMessage': 'Group message',
    'web.channelPanel.archived': 'Archived',
    'web.channelPanel.favourite': 'Favourite',
    'web.channelPanel.working': 'Saving…',
    'web.channelPanel.mutedByCategory': 'Muted by its sidebar category.',
    'web.channelPanel.headerPlaceholder': 'No header',
    'web.channelPanel.purposePlaceholder': 'No purpose',
    'web.channelPanel.openFile': 'Open file',
  },
};
